import {Model, ModelInstance} from './Common';

class DocumentTypeInstance extends ModelInstance {
  constructor(documentType) {
    super(documentType);
    this.labelFr = documentType.labelFr;
    this.labelEn = documentType.labelEn || '';
    this.code = documentType.code || '';
  }
}

export class DocumentType extends Model {
  getMany = documentTypes =>
    documentTypes.map(documentType => new DocumentTypeInstance(documentType));
  getOne = documentType => new DocumentTypeInstance(documentType);
}
